// Manually injects the Google Maps JS API script once the real key is known
// (i.e. after partnerSettings resolves). gmap-vue is installed with
// dynamicLoad: true in GoogleMap.vue, so it only wires up window.GoogleMapsCallback
// and waits - it does not inject the script itself.
const SCRIPT_ID = "google-maps-api-script";

export function loadGoogleMapsApi(apiKey: string): void {
  if (!apiKey || document.getElementById(SCRIPT_ID)) return;

  const script = document.createElement("script");
  script.id = SCRIPT_ID;
  script.src = `https://maps.googleapis.com/maps/api/js?key=${encodeURIComponent(apiKey)}&libraries=places&callback=GoogleMapsCallback`;
  script.async = true;
  script.defer = true;
  document.head.appendChild(script);
}
